import React from 'react';
import PropTypes from 'prop-types';

/**
 * Default sensor icon — fallback for sensor types that have no dedicated icon
 * (e.g. INACTIVE, SENSOR_0_10V, VIRUS_INDEX, AIR_PRESSURE, FORMALDEHYDE, ANALOG_OUTPUT_0_10V).
 */
const GenericSensor = ({ width, height, opacity }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" opacity={opacity}>
    <g clipPath="url(#clip0_generic_sensor)">
      <path
        d="M22 12.0001C22 9.56307 21.13 7.33307 19.683 5.59807L19.043 4.83007L20.578 3.54907L21.218 4.31607C23.0192 6.4711 24.0041 9.19147 24 12.0001C24.0043 14.8084 23.0193 17.5285 21.218 19.6831L20.578 20.4511L19.042 19.1701L19.682 18.4021C21.1833 16.6065 22.004 14.3395 22 11.9991V12.0001ZM17.377 7.51707C18.4277 8.77442 19.0023 10.3615 19 12.0001C19 13.7041 18.39 15.2681 17.377 16.4821L16.737 17.2501L15.201 15.9691L15.841 15.2011C16.5917 14.3035 17.002 13.1702 17 12.0001C17.0023 10.8301 16.5923 9.69676 15.842 8.79907L15.2 8.03007L16.736 6.74907L17.376 7.51607L17.377 7.51707ZM12 10.0001C12.5304 10.0001 13.0392 10.2108 13.4142 10.5859C13.7893 10.9609 14 11.4696 14 12.0001C14 12.5305 13.7893 13.0392 13.4142 13.4143C13.0392 13.7894 12.5304 14.0001 12 14.0001C11.4696 14.0001 10.9609 13.7894 10.5858 13.4143C10.2107 13.0392 10 12.5305 10 12.0001C10 11.4696 10.2107 10.9609 10.5858 10.5859C10.9609 10.2108 11.4696 10.0001 12 10.0001ZM8.79901 8.03007L8.15901 8.79907C7.40856 9.69636 6.99821 10.8293 7.00001 11.9991C7.00001 13.2181 7.43501 14.3321 8.15801 15.1991L8.79901 15.9681L7.26301 17.2481L6.62301 16.4811C5.57274 15.2243 4.99819 13.638 5.00001 12.0001C5.00001 10.2961 5.61001 8.73207 6.62301 7.51807L7.26301 6.75107L8.80001 8.03007H8.79901ZM4.95801 4.83007L4.31801 5.59807C2.8172 7.39308 1.99652 9.65932 2.00001 11.9991C2.00001 14.4351 2.87001 16.6661 4.31701 18.4011L4.95701 19.1691L3.42201 20.4491L2.78201 19.6821C0.981376 17.5275 -0.00349903 14.808 9.34094e-06 12.0001C9.34094e-06 9.07907 1.04501 6.39807 2.78101 4.31707L3.42201 3.55007L4.95801 4.83007Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_generic_sensor">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

GenericSensor.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  opacity: PropTypes.number,
};

GenericSensor.defaultProps = {
  width: 24,
  height: 24,
  opacity: 1,
};

export default GenericSensor;
